<template>
  <v-card>
    <v-card-title>ตรวจสอบคุณภาพการเชื่อมต่อ</v-card-title>
<v-card-text>

    <v-text-field
      v-model.number="threshold"
      label="Threshold (ms)"
      type="number"
      outlined
      class="mb-3"
      disabled
    />

    <v-text-field
      v-model.number="intervalSeconds"
      label="Check Interval (seconds)"
      type="number"
      outlined
      class="mb-3"
      disabled
    />

    <v-btn
      color="primary"
      @click="toggleMonitoring"
    >
      {{ monitoring ? "Stop Monitoring" : "Start Monitoring" }}
    </v-btn>

    <div class="mt-4">
      <p v-if="latency !== null">
        Current Latency: <strong>{{ latency }} ms</strong>
      </p>
      <p v-else>No data yet</p>
    </div>

    <v-snackbar
      v-model="showAlert"
      color="red darken-2"
      timeout="4000"
      centered
    >
      ⚠️ High latency detected: {{ latency }} ms (threshold {{ threshold }} ms)
    </v-snackbar>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LatencyMonitor",
  data() {
    return {
      regionUrl:
        "https://stcmsprdse01.blob.core.windows.net/speedtest/test1MB.bin?sp=r&st=2025-10-10T02:42:29Z&se=2028-10-10T10:57:29Z&spr=https&sv=2024-11-04&sr=b&sig=BXTq73dJZnpUgBsXI1CrlrPg%2B1v5%2Bec7nFWQUfZSSv0%3D",
      latency: null,
      threshold: 300, // ms
      intervalSeconds: 10, // test every 10 seconds
      monitoring: false,
      timer: null,
      showAlert: false,
    };
  },
  methods: {
    async measureLatency() {
      try {
        const start = performance.now();
        await fetch(this.regionUrl + "?cacheBust=" + Date.now(), {
          method: "HEAD",
          cache: "no-store",
        });
        const end = performance.now();
        this.latency = Math.round(end - start);

        if (this.latency > this.threshold) {
          this.showAlert = true;
        }
      } catch (err) {
        console.error("Latency test failed:", err);
        this.latency = null;
      }
    },

    toggleMonitoring() {
      if (this.monitoring) {
        clearInterval(this.timer);
        this.monitoring = false;
      } else {
        this.monitoring = true;
        this.measureLatency(); // run immediately
        this.timer = setInterval(
          this.measureLatency,
          this.intervalSeconds * 1000
        );
      }
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}
</style>
